import { useChains } from "../../../../ChainsContext";

export default function NetworksAndCoins({
  selectedChain,
  selectedToken,
  onSetNetwork,
  onSetCrypto,
  setActiveTab,
  cryllexChains,
}) {

  const mainChains = useChains();

  return (<div>
    <div className="mb-3 title-block">
      <strong >Select Network & Token</strong>
    </div>

    <div className="p-3 text-dark  mb-5">
      <div>{
        cryllexChains && cryllexChains.length && mainChains && mainChains.length ?
          <div>
            <div>
              <p><b className='text-muted'>Networks</b></p>
              <ul className="cx-accordion-body-list flex-wrap" id="crypto-block">
                {
                  mainChains.map((item) => {
                    const isExistChain = cryllexChains.find(el => el.chainId === item.id);
                    if (isExistChain) {
                      return (
                        <li
                          key={isExistChain.id}
                          title={isExistChain.chainName}
                          style={{ cursor: "pointer" }}
                          className={`cx-accordion-list-item px-3 pt-3 mb-3 ${selectedChain && selectedChain.id === isExistChain.id ? "selected-item" : ""}`}
                          onClick={() => {
                            onSetNetwork(isExistChain, setActiveTab);
                          }}
                        >
                          <img src={isExistChain.chainLogo} alt="logo" className='rounded' />
                          <div className="cx-accordion-list-item-name">
                            {isExistChain.chainSlug}
                          </div>
                        </li>
                      );
                    }
                    return null;
                  })
                }
              </ul>
            </div>
            {
              selectedChain && selectedChain.tokens && selectedChain.tokens.length ?
                <div>
                  <hr />
                  <p><b className='text-muted'>Tokens</b></p>
                  <ul className="cx-accordion-body-list" id="crypto-block">
                    {
                      selectedChain.tokens.map(item => {
                        return <li
                          title={item.name}
                          style={{ cursor: "pointer" }}
                          key={item.id}
                          className={`cx-accordion-list-item pt-3 ${selectedToken && selectedToken.id === item.id ? "selected-item" : ""}`}
                          // onClick={() => setSelectedToken(item)}
                          onClick={() => onSetCrypto(item, setActiveTab)}
                        >
                          <img src={item.logo} alt="logo" className='rounded' />
                          <div className="cx-accordion-list-item-name" >
                            {item?.slug}
                          </div>
                        </li>
                      })
                    }
                  </ul>
                </div>
                : null
            }
          </div>
          : null
      }</div>
    </div>
  </div>



  )
}
